import RulesButton from './RulesButton';
export default RulesButton;